import colors from "@areahub/theme/src/foundations/colors";
import { DocumentNode } from "graphql";
export type ProgressCircleType = "full" | "half" | "none";

export function toProgressCircles(score: number): ProgressCircleType[] {
  switch (true) {
    case score <= 5:
      return ["full", "full", "full", "full", "full"];
    case score <= 10:
      return ["full", "full", "full", "full", "half"];
    case score <= 15:
      return ["full", "full", "full", "full", "none"];
    case score <= 20:
      return ["full", "full", "full", "half", "none"];
    case score <= 25:
      return ["full", "full", "full", "none", "none"];
    case score <= 30:
      return ["full", "full", "half", "none", "none"];
    case score <= 35:
      return ["full", "full", "none", "none", "none"];
    case score <= 40:
      return ["full", "half", "none", "none", "none"];
    case score <= 50:
      return ["full", "none", "none", "none", "none"];
    case score <= 90:
      return ["half", "none", "none", "none", "none"];
    case score <= 100:
      return ["none", "none", "none", "none", "none"];
    default:
      return ["none", "none", "none", "none", "none"];
  }
}

export function titleCase(s: string): string {
  try {
    let str = s.toLowerCase().split(" ");
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(" ");
  } catch (e) {
    return s;
  }
}

// util function to convert the input to string type
function convertToString(input: any) {
  if (input) {
    if (typeof input === "string") {
      return input;
    }

    return String(input);
  }
  return "";
}

// convert string to words
function toWords(input: string): string[] {
  input = convertToString(input);

  var regex =
    /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;
  // @ts-ignore
  return input.match(regex);
}

// convert the input array to camel case
function toCamelCase(inputArray: string[]) {
  let result = "";

  for (let i = 0, len = inputArray.length; i < len; i++) {
    let currentStr = inputArray[i];

    let tempStr = currentStr.toLowerCase();

    if (i != 0) {
      // convert first letter to upper case (the word is in lowercase)
      tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1);
    }

    result += tempStr;
  }

  return result;
}

// this function call all other functions

export function toCamelCaseString(input: string) {
  let words = toWords(input);

  return toCamelCase(words);
}

export function extract<T>(properties: Record<keyof T, true>) {
  return function <TActual extends T>(value: TActual) {
    let result = {} as T;
    for (const property of Object.keys(properties) as Array<keyof T>) {
      result[property] = value[property];
    }
    return result;
  };
}

export function fmtThemeColor(color: string) {
  return color?.includes("_") ? color.replace("_", ".") : color;
}

export function fmtEnterpriseThemeColor(color: string) {
  if (color.includes("_")) {
    const bgColorArr = color?.split("_");
    const colorScheme = colors.enterpriseColors[bgColorArr?.[0]];
    const backgroundColor = colorScheme?.[bgColorArr?.[1]];
    return backgroundColor;
  } else {
    return color;
  }
}

export function getGqlString(doc: DocumentNode): string {
  return doc?.loc ? doc?.loc?.source?.body : "";
}

export function filterUnique(value: any, index: number, self: any) {
  return self.indexOf(value) === index;
}

export function checkProperties(obj: any) {
  for (const key in obj) {
    return typeof obj[key] !== "undefined";
  }
  return false;
}

export function checkSubcategoryCounts(metric: any) {
  if (typeof metric === "undefined") {
    return null;
  }
  if (metric === 0) {
    return "0";
  }
  if (metric) {
    if (metric === -1) {
      return "N/A";
    }
    return metric;
  } else {
    return null;
  }
}
